import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  Typography
} from "@mui/material";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledDialog } from "../../../styled/dialog";

const OpenFormQrDialog = ({ onClose, form, open, qr }) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        disableBackdropClick={true}>
        <StyledDialog.MuiDialogTitle
          disableTypography>
          <StyledDialog.Title>{form?.nombre}</StyledDialog.Title>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </StyledDialog.MuiDialogTitle>
        <DialogContent dividers>
          <DialogContentText >
            <StyledDialog.Container>
              <Grid container justifyContent="center" alignItems="center" direction="row">
                {qr ?
                  <img src={qr} />
                  : <CircularLoading sx={{ width: 300, margin: 15 }} />
                }
                <Typography sx={{ fontWeight: 'bold' }} variant="subtitle1" >
                  Escaneá el QR con tu celular para acceder al formulario y adjuntar la documentación respaldatoria de este siniestro.
                </Typography>
              </Grid>
            </StyledDialog.Container>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  )

}

export default OpenFormQrDialog;

